import { render, staticRenderFns } from "./OmProtectEstateCostsCard.vue?vue&type=template&id=1d82459c&scoped=true"
import script from "./OmProtectEstateCostsCard.vue?vue&type=script&lang=js"
export * from "./OmProtectEstateCostsCard.vue?vue&type=script&lang=js"
import style0 from "./OmProtectEstateCostsCard.vue?vue&type=style&index=0&id=1d82459c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d82459c",
  null
  
)

export default component.exports